import React from "react";
import { Chip } from "@hdir/ui/chip";
import { Link } from "@hdir/ui/link";
import {
  faCircleInfo, faClock, faLocationPin, faRepeat
} from "@fortawesome/pro-light-svg-icons";
import FontAwesomeIconWrapper from "../../FontAwesomeIconWrapper/FontAwesomeIconWrapper";
import CardTitleHeader from "../../CardTitleHeader/CardTitleHeader";

import type { EventProps } from "../../../../lib/modules/listSearchUtils/index.d";

export default function Event(props: Readonly<EventProps>) {
  const {
    endDay,
    endMonth,
    endTime,
    endYear,
    eventFinished,
    eventType,
    korttittel,
    link,
    location,
    registrationDeadline,
    startDay,
    startMonth,
    startTime,
    startYear,
    title,
    groupBy
  } = props;

  // Display the card if enough content is present
  const hasEnoughContent = !!(korttittel || title || link);

  const lastsOneDay = startDay === endDay && startMonth === endMonth && startYear === endYear;

  if (hasEnoughContent) {
    return (
      <Link href={link} style={{ padding: 0 }} variant="card" className="min-w-full h-full !flex-row !items-center !justify-items-center min-h-[150px]">
        <div className="flex flex-col items-center justify-items-center h-full w-full">
          {eventFinished && <div className="bg-surface-neutral-grey text-neutral-subtle w-full pl-lg tablet:pl-[120px] py-sm"><p className="font-bold text-lg">Gjennomført</p></div>}
          <div className="flex flex-col tablet:!flex-row w-full min-h-full gap-md py-lg px-lg tablet:items-center tablet:pl-md tablet:pr-xl">
            {(startDay && startMonth && startYear) ? (
              <p className="text-xl flex flex-row tablet:!flex-col gap-xxs tablet:gap-0 font-semibold text-action text-center tablet:w-[110px]">
                {endDay && (startDay !== endDay) ? (
                  <span className="tablet:!text-xxxl tablet:font-bold">{`${startDay}–${endDay} `}</span>
                ) : (
                  <span className="tablet:!text-xxxl tablet:font-bold">{startDay}</span>
                )}

                {endMonth && (startMonth !== endMonth) ? (
                  <span className="tablet:text-md tablet:font-normal">{`${startMonth}–${endMonth}`}</span>
                ) : (
                  <span className="tablet:text-md tablet:font-normal">{`${startMonth}`}</span>
                )}

                {endYear && (startYear !== endYear) ? (
                  <span className="tablet:text-md">{`${startYear}–${endYear}`}</span>
                ) : (
                  <span className="tablet:text-md">{startYear}</span>
                )}
              </p>
            ) : (
              <div className="flex nt-flex-row tablet:nt-flex-col items-center justify-items-center tablet:w-[110px] gap-sm">
                <FontAwesomeIconWrapper icon={faRepeat} className="text-icon-action" size="xl" />
                <p className="text-action text-center text-md tablet:text-xl font-semibold tablet:font-normal">Ingen fast dato</p>
              </div>
            )}

            <div className="flex flex-col gap-md w-full">
              <CardTitleHeader title={title} korttittel={korttittel} groupBy={groupBy} />
              <div className="flex nt-flex-col tablet:nt-flex-row tablet:flex-wrap gap-xs tablet:gap-lg">
                {(startTime && endTime) && (lastsOneDay) && (
                  <div className="flex gap-xs">
                    <FontAwesomeIconWrapper icon={faClock} className="text-icon-action mt-xxs" />
                    <p>{`${startTime}–${endTime}`}</p>
                  </div>
                )}
                {location && (
                  <div className="flex gap-xs">
                    <FontAwesomeIconWrapper icon={faLocationPin} className="text-icon-action mt-xxs" />
                    <p>{location}</p>
                  </div>
                )}
                <div className="flex gap-xs">
                  <FontAwesomeIconWrapper icon={faCircleInfo} className="text-icon-action mt-xxs" />
                  {registrationDeadline ? (
                    <p>{`Påmeldingsfrist ${registrationDeadline}`}</p>
                  ) : (
                    <p>Ingen påmelding</p>
                  )}
                </div>
              </div>
              {(eventType && eventType?.length > 0) && (
                <div className="flex gap-xs">
                  {eventType?.map((type) => (
                    <Chip color="grey">
                      {type}
                    </Chip>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </Link>
    );
  }
}
